import allGamesIcon from "@layouts/betto/assets/all-games.webp";
import homeIcon from "@layouts/betto/assets/home.svg";
import baccaratIcon from "@layouts/betto/assets/baccarat.webp";
import blackjackIcon from "@layouts/betto/assets/blackjack.svg";
import hotGamesIcon from "@layouts/betto/assets/hot-games.webp";
import liveCasinoIcon from "@layouts/betto/assets/icons/live-casino.svg";
import newReleasesIcon from "@layouts/betto/assets/new-releases.webp";
import pokerIcon from "@layouts/betto/assets/poker.webp";
import rouletteIcon from "@layouts/betto/assets/roulette.webp";
import slotGamesIcon from "@layouts/betto/assets/slot-games.webp";
import tableGamesIcon from "@layouts/betto/assets/table-games.webp";

const normalizeCategoryKey = (key = "") =>
	key
		.toLowerCase()
		.replace(/[\s_-]+/g, "")
		.trim();

const CATEGORY_ICON_MAP = {
	allgames: allGamesIcon,
	hotgames: hotGamesIcon,
	hot: hotGamesIcon,
	slotgames: slotGamesIcon,
	slots: slotGamesIcon,
	slot: slotGamesIcon,
	livecasino: liveCasinoIcon,
	live: liveCasinoIcon,
	tablegames: tableGamesIcon,
	table: tableGamesIcon,
	blackjack: blackjackIcon,
	blackjackgames: blackjackIcon,
	roulette: rouletteIcon,
	baccarat: baccaratIcon,
	poker: pokerIcon,
	newreleases: newReleasesIcon,
	new: newReleasesIcon,
};

const CATEGORY_PARTIAL_MATCHES = [
	{ pattern: /black/i, icon: blackjackIcon },
	{ pattern: /roulette/i, icon: rouletteIcon },
	{ pattern: /baccarat/i, icon: baccaratIcon },
	{ pattern: /poker/i, icon: pokerIcon },
	{ pattern: /slot/i, icon: slotGamesIcon },
	{ pattern: /live/i, icon: liveCasinoIcon },
	{ pattern: /table/i, icon: tableGamesIcon },
	{ pattern: /hot/i, icon: hotGamesIcon },
	{ pattern: /new/i, icon: newReleasesIcon },
];

export const getCategoryIcon = (categoryKey) => {
	const normalized = normalizeCategoryKey(categoryKey);
	if (CATEGORY_ICON_MAP[normalized]) {
		return CATEGORY_ICON_MAP[normalized];
	}

	const partialMatch = CATEGORY_PARTIAL_MATCHES.find(({ pattern }) =>
		pattern.test(categoryKey || "")
	);

	return partialMatch?.icon ?? null;
};

export { allGamesIcon, homeIcon };
